import React from "react";
import { CheckCircle2, ExternalLink, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const userRights = [{
  id: "access",
  title: "Right to Access",
  description: "You have the right to request copies of your personal data from us."
}, {
  id: "rectification",
  title: "Right to Rectification",
  description: "You have the right to request that we correct any information you believe is inaccurate or complete information you believe is incomplete."
}, {
  id: "erasure",
  title: "Right to Erasure",
  description: "You have the right to request that we erase your personal data, under certain conditions."
}, {
  id: "restrict",
  title: "Right to Restrict Processing",
  description: "You have the right to request that we restrict the processing of your personal data, under certain conditions."
}, {
  id: "object",
  title: "Right to Object to Processing",
  description: "You have the right to object to our processing of your personal data, under certain conditions."
}, {
  id: "portability",
  title: "Right to Data Portability",
  description: "You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions."
}];
const complaintSteps = [{
  id: "step-1",
  text: "If you have any concerns about our use of your personal information, you can make a complaint to us directly using the contact details provided in our Privacy Policy."
}, {
  id: "step-2",
  text: "We will acknowledge your complaint within 3 working days and aim to resolve it within 30 days."
}, {
  id: "step-3",
  text: "If you remain dissatisfied with our response, you have the right to lodge a complaint with the Information Commissioner's Office (ICO)."
}];
export default function UserRightsIcoInformation() {
  return <section id="user-rights-ico-information" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        
        <div className="mb-12 text-center">
          <h2 className="h2 mb-4 text-primary">User Rights & ICO Information</h2>
          <p className="body-text text-muted-foreground">
            We are committed to protecting your privacy and ensuring you understand your rights regarding your personal data.
          </p>
        </div>

        <div className="space-y-16">
          {}
          <div className="space-y-6">
            <div className="flex items-center gap-3 border-b border-border pb-4">
              <Shield className="size-8 text-primary" />
              <h3 className="h3">Your Data Protection Rights</h3>
            </div>
            
            <ul className="grid gap-4 md:grid-cols-2">
              {userRights.map((right, i) => <li key={right.id} data-index={i} className="bg-card text-card-foreground border border-border rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="size-6 text-primary shrink-0 mt-0.5" />
                    <div>
                      <h4 className="font-bold text-lg mb-2 font-sans">{right.title}</h4>
                      <p className="text-muted-foreground leading-relaxed">
                        {right.description}
                      </p>
                    </div>
                  </div>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <div className="flex items-center gap-3 border-b border-border pb-4">
              <Shield className="size-8 text-primary" />
              <h3 className="h3">Complaint Procedure & ICO</h3>
            </div>

            <div className="bg-muted text-muted-foreground rounded-lg p-6 md:p-8 border border-border">
              <ul className="space-y-4 mb-8">
                {complaintSteps.map((step, i) => <li key={step.id} data-index={i} className="flex gap-4">
                    <span className="flex items-center justify-center size-8 rounded-full bg-primary text-primary-foreground font-bold shrink-0">
                      {i + 1}
                    </span>
                    <p className="body-text pt-1">{step.text}</p>
                  </li>)}
              </ul>

              <div className="bg-background p-6 rounded-md border border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div>
                  <h4 className="font-bold font-sans text-foreground mb-1">Information Commissioner's Office</h4>
                  <p className="text-sm">The UK's independent authority set up to uphold information rights.</p>
                </div>
                <Button asChild variant="default" className="shrink-0">
                  <Link to="https://ico.org.uk/" newTab>
                    Visit ICO Website
                    <ExternalLink className="ml-2 size-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}